import { action, computed, observable } from 'mobx';
import moment from 'moment';
import Api from 'tm3-core/api';
import { cache } from 'tm3-core/cache';
import { ConfigObservable } from './config';
import SnackbarStore from './snackbar-store';

class ReminderStore {
  @observable loading = false;
  @observable reminders = [];
  @observable show = false;
  @observable day = '';
  @observable isEmail = false;
  @observable lastReminderTime = null;

  @action
  onLoad(type, isEmail, date, locationId, appointmentId, practitionerIds) {
    this.loading = true;
    if (moment(date).isValid()) {
      this.day = moment(date).format('ddd Do MMM');
    }
    this.isEmail = isEmail;

    let pId = type === 'P' ? practitionerIds : [];
    let request = {
      day: date,
      isEmail: isEmail,
      locationId: locationId,
      practitionerIds: pId || [],
      appointmentId: appointmentId || 0
    };

    Api.post('/api/reminder/data', request).then((res) => {
      res.body.results.forEach((r) => {
        let sms = r.mobileTelephone || '';
        let email = r.customerEmail || '';

        let hasEmail = isEmail && email.length > 0;
        let hasSms = !isEmail && sms.length > 0 && r.customerSmsEnabled;
        r.include = (hasEmail || hasSms) && r.customerGivenConsent;
        return;
      });
      this.reminders.replace(res.body.results);
      this.loading = false;
      this.show = true;
    });
  }

  @action
  getReminderTime() {
    const { app } = cache;
    const isProntoPortal = cache.licence.get('isProntoPortal');

    if (isProntoPortal || app.Pronto) return;

    Api.get('/api/reminder/last').then((res) => {
      this.lastReminderTime = res.body.result;
    });
  }

  @action
  onSend(reminders, isEmail) {
    let text = !isEmail ? 'SMS successfully queued' : 'Email successfully queued';

    this.reminders.replace(reminders);

    let appointmentIds = reminders.filter((x) => !!x.include).map((r) => r.id);

    Api.post('/api/reminder/send', { appointmentIds, sendEmail: isEmail, sendSms: !isEmail }).then(
      (res) => {
        SnackbarStore.onNotify(text, true);
      }
    );
  }

  @computed
  get ozMode() {
    let { config } = ConfigObservable;
    let mode = config['OZ MODE'] || 'false';
    return mode.toUpperCase() === 'TRUE';
  }

  @computed
  get enabled() {
    let { config } = ConfigObservable;
    let sms = config['S_REMINDERS_SENDSMS'] || 'false';
    let email = config['S_REMINDERS_SENDEMAIL'] || 'false';

    return email.toUpperCase() === 'TRUE' || sms.toUpperCase() === 'TRUE';
  }
}

export default new ReminderStore();
